export default __webpack_public_path__ + "static/media/고블렛잔 만들기 클래스_모바일.9cae7ef9.jpg";